import { Youtube, Instagram, Facebook, Music2 } from "lucide-react";
import { useContent, useSectionMeta } from "../content/ContentContext";
import { Reveal, Chapter } from "./Reveal";

export const Watch = () => {
  const { SOCIALS, SITE } = useContent();
  const meta = useSectionMeta("watch");
  const SECONDARY = [
    { id: "tiktok", label: "TikTok", href: SOCIALS.tiktok, Icon: Music2 },
    { id: "instagram", label: "Instagram", href: SOCIALS.instagram, Icon: Instagram },
    { id: "facebook", label: "Facebook", href: SOCIALS.facebook, Icon: Facebook },
  ];

  return (
    <section id="watch" className="relative py-24 md:py-36 overflow-hidden" data-testid="watch-section">
      <div className="absolute -right-40 bottom-0 w-[520px] h-[520px] rounded-full bg-burgundy/25 blur-[170px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Chapter number={meta.number} label={meta.label} id="watch" />
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-3xl" data-testid="watch-heading">
            WATCH <span className="italic text-gold-light">WE NEED TO TALK</span>
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="font-quote italic text-lg md:text-xl text-smoke mt-6" data-testid="watch-tagline">
            {SITE.watch.tagline}
          </p>
        </Reveal>

        <Reveal delay={0.24}>
          <div className="mt-12 flex flex-col gap-4 max-w-2xl">
            <a
              href={SOCIALS.youtube}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between border border-gold/50 bg-gold/[0.08] hover:bg-gold hover:text-ink text-ivory rounded-sm px-7 md:px-9 py-6 md:py-7 transition-colors duration-500"
              data-testid="social-youtube"
            >
              <span className="flex items-center gap-4">
                <Youtube size={24} />
                <span className="font-display text-xl md:text-2xl tracking-wide">YouTube</span>
              </span>
              <span className="text-[10px] tracking-[0.3em] uppercase opacity-70 group-hover:opacity-100">
                Watch the series
              </span>
            </a>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {SECONDARY.map(({ id, label, href, Icon }) => (
                <a
                  key={id}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center gap-3 border border-white/10 bg-coal/60 hover:border-gold/50 text-ivory/85 hover:text-gold-light rounded-sm px-6 py-5 transition-colors duration-500"
                  data-testid={`social-${id}`}
                >
                  <Icon size={18} />
                  <span className="text-xs tracking-[0.22em] uppercase">{label}</span>
                </a>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
